export const getBandWidthDate = ({
  resolvedStartDate,
  resolvedDate,
}: {
  resolvedStartDate: string | undefined | null;
  resolvedDate: string | undefined | null;
}) => {
  if (resolvedStartDate === resolvedDate) {
    return {
      resolvedEndDate: resolvedDate,
    };
  }

  return {
    resolvedStartDate: resolvedStartDate,
    resolvedEndDate: resolvedDate,
  };
};
